module.exports = __webpack_public_path__ + "static/media/HV Image HV 9065-4 9065-5 & 7054-1 8489-2.c9d0a3ac.jpg";